<div class="page-container">
  <!-- Totals across every project, so the page answers "how much is on me" before any
       group is opened. -->
  <div class="stats-cards-row" *ngIf="!loading">
    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ totalProjects }}</span>
        <span class="stats-card-label">Projects</span>
        <span class="stats-card-sublabel">Allocated this month</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
    </div>

    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ totalTasks }}</span>
        <span class="stats-card-label">Tasks</span>
        <span class="stats-card-sublabel">Across those projects</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-list-check"></i></div>
    </div>

    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ totalDone }}</span>
        <span class="stats-card-label">Done</span>
        <span class="stats-card-sublabel">Completed tasks</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
    </div>
  </div>

  <!-- Year and month live in the main header, shared with Work Log via
       YearMonthFilterService — the same period follows you between the two pages. -->

  <div *ngIf="loading" class="loading-container loading-container--centered">
    <i class="pi pi-spin pi-spinner loading-spinner-icon"></i>
    <p>Loading your projects…</p>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Nothing allocated is a normal state at the start of a month, not an error, so it
         says which month it is talking about. -->
    <div class="empty-state" *ngIf="filteredGroups.length === 0 && !loadFailed">
      <div class="empty-icon"><i class="pi pi-inbox"></i></div>
      <p class="empty-message">
        {{ searchText ? 'No projects match your search' : 'No projects allocated this month' }}
      </p>
      <p class="empty-description">
        {{ searchText
            ? 'Try a different search, or clear it to see every project.'
            : 'Your tasks appear here once you are allocated to a project for the selected month.' }}
      </p>
    </div>

    <!-- One expandable group per project. The backlog inside is the same component the
         Projects module uses, so both views stay identical as it changes. -->
    <div class="mpt-group" *ngFor="let group of filteredGroups">
      <button type="button" class="mpt-group-head"
              [class.mpt-group-head--open]="isExpanded(group.projectId)"
              (click)="toggle(group.projectId)"
              [attr.aria-expanded]="isExpanded(group.projectId)">
        <i class="pi mpt-chevron"
           [ngClass]="isExpanded(group.projectId) ? 'pi-chevron-down' : 'pi-chevron-right'"
           aria-hidden="true"></i>

        <span class="mpt-group-title">
          {{ group.projectName }}
          <span class="mpt-code" *ngIf="group.projectCode">{{ group.projectCode }}</span>
        </span>

        <span class="mpt-client" *ngIf="group.clientName">
          <i class="pi pi-building"></i>{{ group.clientName }}
        </span>

        <span class="mpt-progress" *ngIf="group.taskCount"
              [pTooltip]="group.doneCount + ' of ' + group.taskCount + ' done'"
              tooltipPosition="top">
          <span class="mpt-progress-bar">
            <span class="mpt-progress-fill" [style.width.%]="donePercent(group)"></span>
          </span>
          <span class="mpt-progress-text">{{ group.doneCount }}/{{ group.taskCount }}</span>
        </span>

        <span class="mpt-empty-note" *ngIf="!group.taskCount">No tasks yet</span>
      </button>

      <!-- Rendered only when open: each instance fetches its own backlog, so mounting every
           project at once would fire a request per project on page load. -->
      <div class="mpt-group-body" *ngIf="isExpanded(group.projectId)">
        <app-project-tasks [projectId]="group.projectId"
                           [embedded]="true"
                           [readonlyDelete]="true" />
      </div>
    </div>
  </ng-container>
</div>
